import React, { useMemo, useState } from "react";
import { Alert, Button, Card, Empty, Select, Space, Tag, Typography } from "antd";

export const documentPresets = ["WordPress", "Typecho", "Halo", "Discuz", "Z-Blog", "Emlog", "default-theme"] as const;

// The lifecycle shell intentionally has no legacy-summary fallback: documents
// become readable only after the server reports a ready version.
const DocumentCenter: React.FC = () => {
  const [preset, setPreset] = useState<string>();
  const status = useMemo(() => preset ? "pending" : "empty", [preset]);
  return <Space direction="vertical" size="large" style={{ width: "100%", padding: 24 }}>
    <Typography.Title level={2}>文档中心</Typography.Title>
    <Alert type="info" showIcon message="文档须完成解析后才可被 Agent 读取；删除后可在保留期内恢复。" />
    <Card title="预置文档" extra={<Tag color={status === "pending" ? "processing" : "default"}>{status === "pending" ? "等待解析" : "未选择"}</Tag>}>
      <Space wrap>
        <Select aria-label="document preset" style={{ minWidth: 220 }} placeholder="选择站点系统或主题" value={preset} onChange={setPreset}
          options={documentPresets.map(value => ({ value, label: value }))} />
        <Button type="primary" disabled={!preset}>导入预置文档</Button>
        <Button disabled>上传文档</Button>
      </Space>
    </Card>
    <Card title="文档版本"><Empty description="暂无已解析文档" /></Card>
  </Space>;
};
export default DocumentCenter;
